import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import {
  AddCutomerMutation,
  DeleteCustomerMutation,
  updateCustomerMutation,
} from "../graphQL/graphMutation";

export const addCustomerService = async (values) => {
  try {
    const res = await request(BASEURL, AddCutomerMutation, {
      ...values,
    });
  } catch (err) {
    console.error(err.message, "addCustomerService error");
  }
};

export const updateCustomerServive = async (values, id) => {
  let updateStatus = false;
  let errormessage;
  try {
    const res = await request(BASEURL, updateCustomerMutation, {
      id: id,
      ...values,
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateCustomerServive error");
    errormessage=err.response?.errors?.[0]?.message;
    updateStatus = false;
  }
  return {updateStatus,errormessage};
};

export const delteCustomerService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, DeleteCustomerMutation, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "delteCustomerMutation error");
    delteStatus = false;
  }

  return delteStatus;
};
